<template>
  <div class="mlp-summary-page">
    <div class="mlp-summary-inner">
      <!-- <div class="mlp-title-row">
        <h1 class="mlp-title">物料汇总（按品项）</h1>
        <span v-if="hasValidProductCode" class="mlp-sub">项目/合同 ID：{{ contractId }}</span>
      </div> -->


        <div class="section-title-group">
          <div
            v-for="(item, index) in titleList"
            :key="item.title"
            :class="item.isChoosed ? 'normal-title normal-title-active' : 'normal-title'"
            @click="handleTitleClick(index, item.title)"
          >
            {{ item.title }}
          </div>
        </div>

        <!-- 常规材料：按品项 -->
          <template v-if="activeTab === 'material'">
            <div class="product-table-container">
                <v-table
                class="table-border product-table material-table material-summary-table"
                hover
                fixed-header
                :style="{ maxHeight: `calc(100vh - 240px)` }"
                >
                <thead>
                    <tr>
                    <th
                        v-for="header in projectMaterialSummaryProductHeaders"
                        :key="header.key"
                        :class="['text-' + header.align]"
                        :style="{ width: `${Number(header.minWidth) + 1}px` }"
                    >
                        <div class="align-center">
                        <template v-if="header.key === 'materialName'">
                            <span class="mlp-header-em">{{ header.title }}</span>
                        </template>
                        <template v-else>
                            {{ header.title }}
                        </template>

                        <v-menu v-if="header.key === 'materialName'" location="bottom" :close-on-content-click="false">
                            <template #activator="{ props }">
                            <v-btn
                                icon="mdi-filter"
                                variant="text"
                                density="compact"
                                size="small"
                                v-bind="props"
                                :color="materialSummarySearchForm.materialName.length > 0 ? '#D2475D' : undefined"
                                :class="materialSummarySearchForm.materialName.length > 0 ? 'filter-btn-active' : ''"
                            />
                            </template>
                            <v-card class="filter-menu">
                            <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto">
                                <div class="filter-checkbox-group">
                                <v-checkbox
                                    v-for="option in materialmaterialNamesSummaryOptions"
                                    :key="option"
                                    :label="option"
                                    :model-value="materialSummarySearchForm.materialName.includes(option)"
                                    @update:model-value="checked => handleSummaryCheckboxChange('materialName', option, checked)"
                                    color="#D2475D"
                                    density="compact"
                                    hide-details
                                />
                                </div>
                            </v-card-text>
                            <v-divider />
                            </v-card>
                        </v-menu>

                        <v-menu v-if="header.key === 'product'" location="bottom" :close-on-content-click="false">
                            <template #activator="{ props }">
                            <v-btn
                                icon="mdi-filter"
                                variant="text"
                                density="compact"
                                size="small"
                                v-bind="props"
                                :color="materialSummarySearchForm.productName.length > 0 ? '#D2475D' : undefined"
                                :class="materialSummarySearchForm.productName.length > 0 ? 'filter-btn-active' : ''"
                            />
                            </template>
                            <v-card class="filter-menu">
                            <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto">
                                <div class="filter-checkbox-group">
                                <v-checkbox
                                    v-for="option in materialproductNamesSummaryOptions"
                                    :key="option"
                                    :model-value="materialSummarySearchForm.productName.includes(option)"
                                    @update:model-value="checked => handleSummaryCheckboxChange('productName', option, checked)"
                                    color="#D2475D"
                                    density="compact"
                                    hide-details
                                >
                                    <template #label>
                                    <div class="d-flex flex-column">
                                        <span>{{ option }}</span>
                                    </div>
                                    </template>
                                </v-checkbox>
                                </div>
                            </v-card-text>
                            <v-divider />
                            </v-card>
                        </v-menu>

                        <v-menu v-if="header.key === 'materialSpec'" location="bottom" :close-on-content-click="false">
                            <template #activator="{ props }">
                            <v-btn
                                icon="mdi-filter"
                                variant="text"
                                density="compact"
                                size="small"
                                v-bind="props"
                                :color="materialSummarySearchForm.materialSpec.length > 0 ? '#D2475D' : undefined"
                                :class="materialSummarySearchForm.materialSpec.length > 0 ? 'filter-btn-active' : ''"
                            />
                            </template>
                            <v-card class="filter-menu">
                            <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto">
                                <v-text-field
                                v-model="materialSpecSummaryFilterKeyword"
                                placeholder="搜索规格"
                                density="compact"
                                variant="outlined"
                                clearable
                                hide-details
                                class="mb-2 search-menu"
                                />
                                <div class="filter-checkbox-group">
                                <v-checkbox
                                    v-for="option in filteredMaterialSpecsSummaryOptions"
                                    :key="option"
                                    :label="option"
                                    :model-value="materialSummarySearchForm.materialSpec.includes(option)"
                                    @update:model-value="checked => handleSummaryCheckboxChange('materialSpec', option, checked)"
                                    color="#D2475D"
                                    density="compact"
                                    hide-details
                                />
                                </div>
                            </v-card-text>
                            <v-divider />
                            </v-card>
                        </v-menu>

                        <v-menu v-if="header.key === 'materialCode'" location="bottom" :close-on-content-click="false">
                            <template #activator="{ props }">
                            <v-btn
                                icon="mdi-filter"
                                variant="text"
                                density="compact"
                                size="small"
                                v-bind="props"
                                :color="materialSummarySearchForm.materialCode.length > 0 ? '#D2475D' : undefined"
                                :class="materialSummarySearchForm.materialCode.length > 0 ? 'filter-btn-active' : ''"
                            />
                            </template>
                            <v-card class="filter-menu">
                            <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto">
                                <v-text-field
                                v-model="materialCodeSummaryFilterKeyword"
                                placeholder="搜索编号"
                                density="compact"
                                variant="outlined"
                                clearable
                                hide-details
                                class="mb-2 search-menu"
                                />
                                <div class="filter-checkbox-group">
                                <v-checkbox
                                    v-for="option in filteredMaterialCodesSummaryOptions"
                                    :key="String(option)"
                                    :label="String(option)"
                                    :model-value="materialSummarySearchForm.materialCode.includes(String(option))"
                                    @update:model-value="checked => handleSummaryCheckboxChange('materialCode', String(option), checked)"
                                    color="#D2475D"
                                    density="compact"
                                    hide-details
                                />
                                </div>
                            </v-card-text>
                            <v-divider />
                            </v-card>
                        </v-menu>

                        <v-menu v-if="header.key === 'bigClass'" location="bottom" :close-on-content-click="false">
                            <template #activator="{ props }">
                            <v-btn
                                icon="mdi-filter"
                                variant="text"
                                density="compact"
                                size="small"
                                v-bind="props"
                                :color="materialSummarySearchForm.bigClass.length > 0 ? '#D2475D' : undefined"
                                :class="materialSummarySearchForm.bigClass.length > 0 ? 'filter-btn-active' : ''"
                            />
                            </template>
                            <v-card class="filter-menu">
                            <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto">
                                <div class="filter-checkbox-group">
                                <v-checkbox
                                    v-for="option in materialbigClassesSummaryOptions"
                                    :key="option"
                                    :label="option"
                                    :model-value="materialSummarySearchForm.bigClass.includes(option)"
                                    @update:model-value="checked => handleSummaryCheckboxChange('bigClass', option, checked)"
                                    color="#D2475D"
                                    density="compact"
                                    hide-details
                                />
                                </div>
                            </v-card-text>
                            <v-divider />
                            </v-card>
                        </v-menu>

                        <v-menu v-if="header.key === 'smallClass'" location="bottom" :close-on-content-click="false">
                            <template #activator="{ props }">
                            <v-btn
                                icon="mdi-filter"
                                variant="text"
                                density="compact"
                                size="small"
                                v-bind="props"
                                :color="materialSummarySearchForm.smallClass.length > 0 ? '#D2475D' : undefined"
                                :class="materialSummarySearchForm.smallClass.length > 0 ? 'filter-btn-active' : ''"
                            />
                            </template>
                            <v-card class="filter-menu">
                            <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto">
                                <div class="filter-checkbox-group">
                                <v-checkbox
                                    v-for="option in materialsmallClassesSummaryOptions"
                                    :key="option"
                                    :label="option"
                                    :model-value="materialSummarySearchForm.smallClass.includes(option)"
                                    @update:model-value="checked => handleSummaryCheckboxChange('smallClass', option, checked)"
                                    color="#D2475D"
                                    density="compact"
                                    hide-details
                                />
                                </div>
                            </v-card-text>
                            <v-divider />
                            </v-card>
                        </v-menu>
                        </div>
                    </th>
                    </tr>
                </thead>
                <tbody class="material-summary-table-body">
                    <tr v-if="loadingMaterialSummary" class="text-center">
                    <td :colspan="projectMaterialSummaryProductHeaders.length" class="py-8">
                        <v-progress-circular indeterminate color="primary" size="40" width="3" />
                        <div class="mt-2 text-grey">加载中...</div>
                    </td>
                    </tr>
                    <tr v-else-if="materialSummaryProductList.length === 0" class="text-center">
                    <td :colspan="projectMaterialSummaryProductHeaders.length" class="py-8">料单暂无数据</td>
                    </tr>
                    <template v-else>
                    <template v-for="(productItem, pIndex) in materialSummaryProductList">
                        <tr v-for="(item, index) in productItem.summaryList || []" :key="`${pIndex}-${index}`">
                        <td
                            v-if="index === 0"
                            :rowspan="(productItem.summaryList && productItem.summaryList.length) || 1"
                            colspan="2"
                            class="product-info-cell-border text-left"
                        >
                            <div
                              v-if="productItem.product?.imageUrls && parseProductImageUrl(productItem.product.imageUrls)"
                              style="position: relative;background:rgba(0, 0, 0, 0.5);width: 100px;height: 100px;line-height: 100px;"
                            >
                            <v-img :src="productThumbSrc(productItem.product.imageUrls)" width="100" height="100" />
                            <v-img
                                v-if="productItem.product.typeOf == '一厂'"
                                style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 0;"
                                :src="allotOneImg"
                                width="30"
                                height="18"
                            />
                            <v-img
                                v-else-if="productItem.product.typeOf == '二厂'"
                                style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 0;"
                                :src="allotTwoImg"
                                width="30"
                                height="18"
                            />
                            <v-img
                                v-else-if="productItem.product.typeOf == '三厂'"
                                style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 0;"
                                :src="allotThreeImg"
                                width="30"
                                height="18"
                            />
                            <v-img
                                v-else-if="productItem.product.typeOf == '四厂'"
                                style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 0;"
                                :src="allotFourImg"
                                width="30"
                                height="18"
                            />
                            </div>
                            <div v-else class="no-img" style="position: relative;width: 100px;height: 100px;line-height: 100px;">
                            <v-img
                                v-if="productItem.product.typeOf == '一厂'"
                                style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 0;"
                                :src="allotOneImg"
                                width="30"
                                height="18"
                            />
                            <v-img
                                v-else-if="productItem.product.typeOf == '二厂'"
                                style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 0;"
                                :src="allotTwoImg"
                                width="30"
                                height="18"
                            />
                            <v-img
                                v-else-if="productItem.product.typeOf == '三厂'"
                                style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 0;"
                                :src="allotThreeImg"
                                width="30"
                                height="18"
                            />
                            <v-img
                                v-else-if="productItem.product.typeOf == '四厂'"
                                style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 0;"
                                :src="allotFourImg"
                                width="30"
                                height="18"
                            />
                            </div>
                            <div class="product-text ml-2 text-left">
                            <div v-if="productItem.product?.name">{{ productItem.product?.name }}</div>
                            <div v-if="productItem.product?.code" style="font-size: 12px;color: rgb(143, 144, 147);">{{ productItem.product?.code }}</div>
                            <div v-if="productItem.product?.batch" style="font-size: 12px;color: rgb(143, 144, 147);">{{ productItem.product?.batch }}</div>
                            <div v-if="productItem.product?.syscode" style="font-size: 12px;color: rgb(143, 144, 147);">{{ productItem.product?.syscode }}</div>
                            <div v-if="productItem.product?.count" style="font-size: 12px;color: rgb(143, 144, 147);">产品数量 {{ productItem.product?.count }}</div>
                            <div v-if="productItem.product?.uploadUserName" style="font-size: 12px;color: rgb(143, 144, 147);">
                                料单上传人 {{ productItem.product?.uploadUserName }}
                            </div>
                            <v-btn style="margin-top: 6px;" class="list-edit-btn" @click="handleProductionManufactureToDesign(productItem.product)">图纸</v-btn>
                            </div>
                        </td>
                        <td class="text-center">{{ item.materialName || '/' }}</td>
                        <td class="text-center">{{ item.materialSpec || '/' }}</td>
                        <td class="text-center">{{ item.materialCode || '/' }}</td>
                        <td class="text-center">{{ item.bigClass || '/' }}</td>
                        <td class="text-center">{{ item.smallClass || '/' }}</td>
                        <td class="text-center">
                            <template v-if="item.totalUsage">
                            {{ formatNumberUse(item.totalUsage) }}
                            <template v-if="item.materialUsageUnit">{{ item.materialUsageUnit }}</template>
                            </template>
                            <template v-else>/</template>
                        </td>
                        <td class="text-center">
                            <template v-if="item.productUsageSum">
                            {{ formatNumberUse(item.productUsageSum) }}
                            <template v-if="item.materialUsageUnit">{{ item.materialUsageUnit }}</template>
                            </template>
                            <template v-else>/</template>
                        </td>
                        <td class="text-center">
                            <v-btn
                            v-if="item.purchaseList?.length > 0"
                            class="list-edit-btn"
                            style="margin: 0!important;"
                            @click="handleSeeMaterialPurchaseList(item, 'material', 1)"
                            >
                            查看
                            </v-btn>
                            <v-img class="statusImg" v-if="item.purchaseItemList?.length > 0 && !item.purchaseList?.length" :src="yijiagouImg"/>
                            <!-- <v-img class="statusImg" v-if="item.purchaseList?.length > 0" :src="yixiadanImg"/> -->
                        </td>
                        <td class="text-center">
                          <!-- <template v-if="item.purchaseList?.length > 0 || item.purchaseItemList?.length > 0"></template>
                          <template v-else> -->
                            <v-checkbox
                              v-if="showFactoryChoosePurchase"
                              :model-value="selectedFactoryMaterials.includes(buildFactorySummaryKey(item, productItem, pIndex, index))"
                              @update:model-value="checked => handleChooseFactorySummaryMaterial(item, checked, productItem, pIndex, index)"
                              hide-details
                              density="compact"
                            />
                            <!-- :disabled="!isUnpurchasedRow(item)" -->
                          <!-- </template> -->
                        </td>
                        </tr>
                    </template>
                    </template>
                </tbody>
                </v-table>
                <div class="custom-pagination d-flex align-center justify-space-between">
                <div class="pagination-info">共 {{ materialSummaryPagination.total }} 条记录</div>
                <div class="d-flex align-center">
                    <div class="pagination-controls">
                    <v-btn
                        icon="mdi-chevron-double-left"
                        variant="text"
                        density="comfortable"
                        :disabled="materialSummaryPagination.page === 1"
                        class="pagination-btn"
                        @click="handleMaterialSummaryPageChange(1)"
                    />
                    <v-btn
                        icon="mdi-chevron-left"
                        variant="text"
                        density="comfortable"
                        :disabled="materialSummaryPagination.page === 1"
                        class="pagination-btn"
                        @click="handleMaterialSummaryPageChange(materialSummaryPagination.page - 1)"
                    />
                    <span class="pagination-text mx-2">{{ materialSummaryPagination.page }} / {{ materialSummaryTotalPages }}</span>
                    <v-btn
                        icon="mdi-chevron-right"
                        variant="text"
                        density="comfortable"
                        :disabled="materialSummaryPagination.page === materialSummaryTotalPages"
                        class="pagination-btn"
                        @click="handleMaterialSummaryPageChange(materialSummaryPagination.page + 1)"
                    />
                    <v-btn
                        icon="mdi-chevron-double-right"
                        variant="text"
                        density="comfortable"
                        :disabled="materialSummaryPagination.page === materialSummaryTotalPages"
                        class="pagination-btn"
                        @click="handleMaterialSummaryPageChange(materialSummaryTotalPages)"
                    />
                    </div>
                </div>
                </div>
            </div>
            </template>

            <!-- 定制&五金：按品项 -->
            <template v-if="activeTab === 'metal'">
            <div class="product-table-container">
                <v-table
                class="table-border product-table material-table material-summary-table"
                hover
                fixed-header
                :style="{ maxHeight: `calc(100vh - 240px)` }"
                >
                <thead>
                    <tr>
                    <th
                        v-for="header in projectFiveMetalSummaryProductHeaders"
                        :key="header.key"
                        :class="['text-' + header.align]"
                        :style="{ minWidth: `${Number(header.minWidth) + 1}px` }"
                    >
                        <div class="align-center">
                        <template v-if="header.key === 'materialName'">
                            <span class="mlp-header-em">{{ header.title }}</span>
                        </template>
                        <template v-else>
                            {{ header.title }}
                        </template>

                        <v-menu v-if="header.key === 'product'" location="bottom" :close-on-content-click="false">
                            <template #activator="{ props }">
                            <v-btn
                                icon="mdi-filter"
                                variant="text"
                                density="compact"
                                size="small"
                                v-bind="props"
                                :color="metalSummarySearchForm.productName.length > 0 ? '#D2475D' : undefined"
                                :class="metalSummarySearchForm.productName.length > 0 ? 'filter-btn-active' : ''"
                            />
                            </template>
                            <v-card class="filter-menu">
                            <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto">
                                <div class="filter-checkbox-group">
                                <v-checkbox
                                    v-for="option in metalproductNamesOptions"
                                    :key="option"
                                    :label="option"
                                    :model-value="metalSummarySearchForm.productName.includes(option)"
                                    @update:model-value="checked => handleMetalSummaryCheckboxChange('productName', option, checked)"
                                    color="#D2475D"
                                    density="compact"
                                    hide-details
                                />
                                </div>
                            </v-card-text>
                            <v-divider />
                            </v-card>
                        </v-menu>

                        <v-menu v-if="header.key === 'partName'" location="bottom" :close-on-content-click="false">
                            <template #activator="{ props }">
                            <v-btn
                                icon="mdi-filter"
                                variant="text"
                                density="compact"
                                size="small"
                                v-bind="props"
                                :color="metalSummarySearchForm.partName.length > 0 ? '#D2475D' : undefined"
                                :class="metalSummarySearchForm.partName.length > 0 ? 'filter-btn-active' : ''"
                            />
                            </template>
                            <v-card class="filter-menu">
                            <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto">
                                <div class="filter-checkbox-group">
                                <v-checkbox
                                    v-for="option in metalSummaryPartNamesOptions"
                                    :key="option"
                                    :label="option"
                                    :model-value="metalSummarySearchForm.partName.includes(option)"
                                    @update:model-value="checked => handleMetalSummaryCheckboxChange('partName', option, checked)"
                                    color="#D2475D"
                                    density="compact"
                                    hide-details
                                />
                                </div>
                            </v-card-text>
                            <v-divider />
                            </v-card>
                        </v-menu>

                        <v-menu v-if="header.key === 'materialName'" location="bottom" :close-on-content-click="false">
                            <template #activator="{ props }">
                            <v-btn
                                icon="mdi-filter"
                                variant="text"
                                density="compact"
                                size="small"
                                v-bind="props"
                                :color="metalSummarySearchForm.materialName.length > 0 ? '#D2475D' : undefined"
                                :class="metalSummarySearchForm.materialName.length > 0 ? 'filter-btn-active' : ''"
                            />
                            </template>
                            <v-card class="filter-menu">
                            <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto">
                                <div class="filter-checkbox-group">
                                <v-checkbox
                                    v-for="option in metalSummaryMaterialNamesOptions"
                                    :key="option"
                                    :label="option"
                                    :model-value="metalSummarySearchForm.materialName.includes(option)"
                                    @update:model-value="checked => handleMetalSummaryCheckboxChange('materialName', option, checked)"
                                    color="#D2475D"
                                    density="compact"
                                    hide-details
                                />
                                </div>
                            </v-card-text>
                            <v-divider />
                            </v-card>
                        </v-menu>

                        <v-menu v-if="header.key === 'materialSpec'" location="bottom" :close-on-content-click="false">
                            <template #activator="{ props }">
                            <v-btn
                                icon="mdi-filter"
                                variant="text"
                                density="compact"
                                size="small"
                                v-bind="props"
                                :color="metalSummarySearchForm.materialSpec.length > 0 ? '#D2475D' : undefined"
                                :class="metalSummarySearchForm.materialSpec.length > 0 ? 'filter-btn-active' : ''"
                            />
                            </template>
                            <v-card class="filter-menu">
                            <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto">
                                <v-text-field
                                v-model="metalSummaryMetalSpecFilterKeyword"
                                placeholder="搜索规格"
                                density="compact"
                                variant="outlined"
                                clearable
                                hide-details
                                class="mb-2 search-menu"
                                />
                                <div class="filter-checkbox-group">
                                <v-checkbox
                                    v-for="option in filteredMetalSummaryMetalSpecsOptions"
                                    :key="option"
                                    :label="option"
                                    :model-value="metalSummarySearchForm.materialSpec.includes(option)"
                                    @update:model-value="checked => handleMetalSummaryCheckboxChange('materialSpec', option, checked)"
                                    color="#D2475D"
                                    density="compact"
                                    hide-details
                                />
                                </div>
                            </v-card-text>
                            <v-divider />
                            </v-card>
                        </v-menu>

                        <v-menu v-if="header.key === 'materialCode'" location="bottom" :close-on-content-click="false">
                            <template #activator="{ props }">
                            <v-btn
                                icon="mdi-filter"
                                variant="text"
                                density="compact"
                                size="small"
                                v-bind="props"
                                :color="metalSummarySearchForm.materialCode.length > 0 ? '#D2475D' : undefined"
                                :class="metalSummarySearchForm.materialCode.length > 0 ? 'filter-btn-active' : ''"
                            />
                            </template>
                            <v-card class="filter-menu">
                            <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto">
                                <v-text-field
                                v-model="metalSummaryMaterialCodeFilterKeyword"
                                placeholder="搜索编号"
                                density="compact"
                                variant="outlined"
                                clearable
                                hide-details
                                class="mb-2 search-menu"
                                />
                                <div class="filter-checkbox-group">
                                <v-checkbox
                                    v-for="option in filteredMetalSummaryMaterialCodesOptions"
                                    :key="String(option)"
                                    :label="String(option)"
                                    :model-value="metalSummarySearchForm.materialCode.includes(String(option))"
                                    @update:model-value="checked => handleMetalSummaryCheckboxChange('materialCode', String(option), checked)"
                                    color="#D2475D"
                                    density="compact"
                                    hide-details
                                />
                                </div>
                            </v-card-text>
                            <v-divider />
                            </v-card>
                        </v-menu>

                        <v-menu v-if="header.key === 'bigClass'" location="bottom" :close-on-content-click="false">
                            <template #activator="{ props }">
                            <v-btn
                                icon="mdi-filter"
                                variant="text"
                                density="compact"
                                size="small"
                                v-bind="props"
                                :color="metalSummarySearchForm.bigClass.length > 0 ? '#D2475D' : undefined"
                                :class="metalSummarySearchForm.bigClass.length > 0 ? 'filter-btn-active' : ''"
                            />
                            </template>
                            <v-card class="filter-menu">
                            <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto">
                                <div class="filter-checkbox-group">
                                <v-checkbox
                                    v-for="option in metalSummaryBigClassesOptions"
                                    :key="option"
                                    :label="option"
                                    :model-value="metalSummarySearchForm.bigClass.includes(option)"
                                    @update:model-value="checked => handleMetalSummaryCheckboxChange('bigClass', option, checked)"
                                    color="#D2475D"
                                    density="compact"
                                    hide-details
                                />
                                </div>
                            </v-card-text>
                            <v-divider />
                            </v-card>
                        </v-menu>

                        <v-menu v-if="header.key === 'smallClass'" location="bottom" :close-on-content-click="false">
                            <template #activator="{ props }">
                            <v-btn
                                icon="mdi-filter"
                                variant="text"
                                density="compact"
                                size="small"
                                v-bind="props"
                                :color="metalSummarySearchForm.smallClass.length > 0 ? '#D2475D' : undefined"
                                :class="metalSummarySearchForm.smallClass.length > 0 ? 'filter-btn-active' : ''"
                            />
                            </template>
                            <v-card class="filter-menu">
                            <v-card-text class="pa-2 filter-menu-text" style="max-width: 200px; max-height: 300px; overflow-y: auto">
                                <div class="filter-checkbox-group">
                                <v-checkbox
                                    v-for="option in metalSummarySmallClassesOptions"
                                    :key="option"
                                    :label="option"
                                    :model-value="metalSummarySearchForm.smallClass.includes(option)"
                                    @update:model-value="checked => handleMetalSummaryCheckboxChange('smallClass', option, checked)"
                                    color="#D2475D"
                                    density="compact"
                                    hide-details
                                />
                                </div>
                            </v-card-text>
                            <v-divider />
                            </v-card>
                        </v-menu>
                        </div>
                    </th>
                    </tr>
                </thead>
                <tbody class="material-summary-table-body">
                    <tr v-if="loadingMetalSummary" class="text-center">
                    <td :colspan="projectFiveMetalSummaryProductHeaders.length" class="py-8">
                        <v-progress-circular indeterminate color="primary" size="40" width="3" />
                        <div class="mt-2 text-grey">加载中...</div>
                    </td>
                    </tr>
                    <tr v-else-if="mergeProductionMetalSummaryProductItems.length === 0" class="text-center">
                    <td :colspan="projectFiveMetalSummaryProductHeaders.length" class="py-8">料单暂无数据</td>
                    </tr>
                    <template v-else>
                    <template v-for="(productItem, pIndex) in mergeProductionMetalSummaryProductItems">
                        <tr v-for="(item, index) in productItem.summaryList || []" :key="`${pIndex}-${index}`">
                        <td
                            v-if="index === 0"
                            :rowspan="(productItem.summaryList && productItem.summaryList.length) || 1"
                            colspan="2"
                            class="product-info-cell-border text-left"
                        >
                            <div
                              v-if="productItem.product?.imageUrls && parseProductImageUrl(productItem.product.imageUrls)"
                              style="position: relative;background:rgba(0, 0, 0, 0.5);width: 100px;height: 100px;line-height: 100px;"
                            >
                            <v-img :src="productThumbSrc(productItem.product.imageUrls)" width="100" height="100" />
                            <v-img
                                v-if="productItem.product.typeOf == '一厂'"
                                style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 99;"
                                :src="allotOneImg"
                                width="30"
                                height="18"
                            />
                            <v-img
                                v-else-if="productItem.product.typeOf == '二厂'"
                                style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 99;"
                                :src="allotTwoImg"
                                width="30"
                                height="18"
                            />
                            <v-img
                                v-else-if="productItem.product.typeOf == '三厂'"
                                style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 99;"
                                :src="allotThreeImg"
                                width="30"
                                height="18"
                            />
                            <v-img
                                v-else-if="productItem.product.typeOf == '四厂'"
                                style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 99;"
                                :src="allotFourImg"
                                width="30"
                                height="18"
                            />
                            </div>
                            <div v-else class="no-img" style="position: relative;width: 100px;height: 100px;line-height: 100px;">
                            <v-img
                                v-if="productItem.product.typeOf == '一厂'"
                                style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 99;"
                                :src="allotOneImg"
                                width="30"
                                height="18"
                            />
                            <v-img
                                v-else-if="productItem.product.typeOf == '二厂'"
                                style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 99;"
                                :src="allotTwoImg"
                                width="30"
                                height="18"
                            />
                            <v-img
                                v-else-if="productItem.product.typeOf == '三厂'"
                                style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 99;"
                                :src="allotThreeImg"
                                width="30"
                                height="18"
                            />
                            <v-img
                                v-else-if="productItem.product.typeOf == '四厂'"
                                style="position: absolute;top: 2px;right: 2px;width: 30px;height: 18px;z-index: 99;"
                                :src="allotFourImg"
                                width="30"
                                height="18"
                            />
                            </div>
                            <div class="product-text ml-2 text-left">
                            <div v-if="productItem.product?.name">{{ productItem.product?.name }}</div>
                            <div v-if="productItem.product?.code" style="font-size: 12px;color: rgb(143, 144, 147);">{{ productItem.product?.code }}</div>
                            <div v-if="productItem.product?.batch" style="font-size: 12px;color: rgb(143, 144, 147);">{{ productItem.product?.batch }}</div>
                            <div v-if="productItem.product?.syscode" style="font-size: 12px;color: rgb(143, 144, 147);">{{ productItem.product?.syscode }}</div>
                            <div v-if="productItem.product?.count" style="font-size: 12px;color: rgb(143, 144, 147);">产品数量 {{ productItem.product?.count }}</div>
                            <div v-if="productItem.product?.uploadUserName" style="font-size: 12px;color: rgb(143, 144, 147);">
                                料单上传人 {{ productItem.product?.uploadUserName }}
                            </div>
                            <v-btn style="margin-top: 6px;" class="list-edit-btn" @click="handleProductionManufactureToDesign(productItem.product)">图纸</v-btn>
                            </div>
                        </td>
                        <td class="text-center">{{ item.partName || '/' }}</td>
                        <td class="text-center">{{ item.materialName || '/' }}</td>
                        <td class="text-center">{{ item.materialSpec || '/' }}</td>
                        <td class="text-center">{{ item.materialCode || '/' }}</td>
                        <td class="text-left" style="padding-left: 16px!important;text-align: left!important;">
                            <template v-if="item.width || item.depth || item.height">
                            <template v-if="item.width">W:{{ item.width || '/' }} <br></template>
                            <template v-if="item.depth">D:{{ item.depth || '/' }} <br></template>
                            <template v-if="item.height">H:{{ item.height || '/' }}</template>
                            </template>
                            <template v-else>/</template>
                        </td>
                        <td class="text-center">{{ item.remark || '/' }}</td>
                        <td class="text-center">{{ item.bigClass || '/' }}</td>
                        <td class="text-center">{{ item.smallClass || '/' }}</td>
                        <td class="text-center">
                            <template v-if="item.totalUsage">
                            {{ item.totalUsage }}
                            <template v-if="item.materialUsageUnit">{{ item.materialUsageUnit }}</template>
                            </template>
                            <template v-else>/</template>
                        </td>
                        <td class="text-center">
                            <template v-if="item.productUsageSum">
                            {{ item.productUsageSum }}
                            <template v-if="item.materialUsageUnit">{{ item.materialUsageUnit }}</template>
                            </template>
                            <template v-else>/</template>
                        </td>
                        <td class="text-center">
                            <v-btn
                            v-if="item.purchaseList?.length > 0"
                            class="list-edit-btn"
                            style="margin: 0!important;"
                            @click="handleSeeMaterialPurchaseList(item, 'hardware', 1)"
                            >
                            查看
                            </v-btn>
                            <v-img class="statusImg" v-if="item.purchaseItemList?.length > 0 && !item.purchaseList?.length" :src="yijiagouImg"/>
                            <!-- <v-img class="statusImg" v-if="item.purchaseList?.length > 0" :src="yixiadanImg"/> -->
                        </td>
                        <td class="text-center">
                          <!-- <template v-if="item.purchaseList?.length > 0 || item.purchaseItemList?.length > 0"></template>
                          <template v-else> -->
                            <v-checkbox
                              v-if="showFactoryChoosePurchaseHardware"
                              :model-value="selectedHardwareMaterials.includes(buildHardwareSummaryKey(item, productItem, pIndex, index))"
                              @update:model-value="checked => handleChooseHardwareSummaryMaterial(item, checked, productItem, pIndex, index)"
                              hide-details
                              density="compact"
                            />
                            <!-- :disabled="!isUnpurchasedRow(item)" -->
                          <!-- </template> -->
                        </td>
                        </tr>
                    </template>
                    </template>
                </tbody>
                </v-table>
                <div class="custom-pagination d-flex align-center justify-space-between">
                <div class="pagination-info">共 {{ metalSummaryPagination.total }} 条记录</div>
                <div class="d-flex align-center">
                    <div class="pagination-controls">
                    <v-btn
                        icon="mdi-chevron-double-left"
                        variant="text"
                        density="comfortable"
                        :disabled="metalSummaryPagination.page === 1"
                        class="pagination-btn"
                        @click="handleMetalSummaryPageChange(1)"
                    />
                    <v-btn
                        icon="mdi-chevron-left"
                        variant="text"
                        density="comfortable"
                        :disabled="metalSummaryPagination.page === 1"
                        class="pagination-btn"
                        @click="handleMetalSummaryPageChange(metalSummaryPagination.page - 1)"
                    />
                    <span class="pagination-text mx-2">{{ metalSummaryPagination.page }} / {{ metalSummaryTotalPages }}</span>
                    <v-btn
                        icon="mdi-chevron-right"
                        variant="text"
                        density="comfortable"
                        :disabled="metalSummaryPagination.page === metalSummaryTotalPages"
                        class="pagination-btn"
                        @click="handleMetalSummaryPageChange(metalSummaryPagination.page + 1)"
                    />
                    <v-btn
                        icon="mdi-chevron-double-right"
                        variant="text"
                        density="comfortable"
                        :disabled="metalSummaryPagination.page === metalSummaryTotalPages"
                        class="pagination-btn"
                        @click="handleMetalSummaryPageChange(metalSummaryTotalPages)"
                    />
                    </div>
                </div>
                </div>
            </div>
        </template>
        <div class="form-actions">
            <v-btn v-if="currentChooseAction !== ''" color="error" variant="tonal" @click="handleCancelPurchase">
              取消
            </v-btn>
            <v-btn v-if="currentChooseAction === 'direct' || currentChooseAction === ''" color="primary" variant="flat" @click="currentChooseAction === '' ? startDirectPurchase() : handleDirectPurchase()">
              <v-img :src="purchaseCaseImg" width="20" height="20" class="mr-1" />
              {{ currentChooseAction === '' ? '直接采购' : '确定' }}
            </v-btn>
            <v-btn v-if="currentChooseAction === 'add' || currentChooseAction === ''" color="primary" variant="flat" @click="currentChooseAction === '' ? startAddPurchase() : handleAddPurchase()">
              <v-img :src="purchaseCarImg" width="20" height="20" class="mr-1" />
              {{ currentChooseAction === '' ? '加采购项' : '确定' }}
            </v-btn>
        </div>
        <AddPurchaseItemDialog
          v-model="showAddPurchaseItemDialog"
          :rows="addPurchaseDialogRows"
          :project-name="addPurchaseDialogProjectName"
          :contract-code="addPurchaseDialogContractCode"
          :contract-id="contractId"
          :product-order-item-id="productOrderItemId"
          :warehouse-no="addPurchaseWarehouseNo"
          @success="handleAddPurchaseItemsSuccess"
        />
        <PurchaseDialog
          ref="purchaseDialogRef"
          :warehouse-options="formattedWarehouseList"
          :allow-warehouse-select="true"
          :contract-id="contractId"
          :project-name="addPurchaseDialogProjectName"
          :contract-code="addPurchaseDialogContractCode"
          @success="handlePurchaseSuccessFromDialog"
        />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { contractApi, goodsManageApi } from '@/services/api'
import { useSnackbar } from '@/composables/useSnackbar'
import PurchaseDialog from '@/components/PurchaseDialog.vue'
import AddPurchaseItemDialog from '@/components/AddPurchaseItemDialog.vue'
import allotOneImg from '@/assets/allotOne.png'
import allotTwoImg from '@/assets/allotTwo.png'
import allotThreeImg from '@/assets/allotThree.png'
import allotFourImg from '@/assets/allotFour.png'
import purchaseCaseImg from '@/assets/purchaseCase.png'
import purchaseCarImg from '@/assets/purchaseCar.png'
import yijiagouImg from '@/assets/yijiagou.png'
import yixiadanImg from '@/assets/yixiadan.png'
interface ApiResponse {
  code: number
  message?: string
  data?: any
}

interface WarehouseItemOptions {
  warehouseNo: string
  warehouseName: string
  warehouseAddress: string
}

interface TitleItem {
  title: string
  isChoosed: boolean
}

const projectMaterialSummaryProductHeaders = [
  { title: '产品图', key: 'productImage', align: 'center', minWidth: '100' },
  { title: '产品', key: 'product', align: 'left', minWidth: '160' },
  { title: '物料名称', key: 'materialName', align: 'center', minWidth: '150' },
  { title: '物料规格', key: 'materialSpec', align: 'center', minWidth: '150' },
  { title: '物料编号', key: 'materialCode', align: 'center', minWidth: '150' },
  { title: '大类', key: 'bigClass', align: 'center', minWidth: '90' },
  { title: '小类', key: 'smallClass', align: 'center', minWidth: '90' },
  { title: '单件用量', key: 'totalUsage', align: 'center', minWidth: '150' },
  { title: '总用量', key: 'productTotalUsage', align: 'center', minWidth: '150' },
  { title: '关联采购', key: 'purchaseNum', align: 'center', minWidth: '90' },
  { title: '操作', key: 'actions', align: 'center', minWidth: '90' }
]

const projectFiveMetalSummaryProductHeaders = [
  { title: '产品图', key: 'productImage', align: 'center', minWidth: '100' },
  { title: '产品', key: 'product', align: 'left', minWidth: '100' },
  { title: '零件', key: 'partName', align: 'center', minWidth: '80' },
  { title: '物料名称', key: 'materialName', align: 'center', minWidth: '120' },
  { title: '物料规格', key: 'materialSpec', align: 'center', minWidth: '120' },
  { title: '物料编号', key: 'materialCode', align: 'center', minWidth: '120' },
  { title: '尺寸', key: 'width', align: 'center', minWidth: '100' },
  { title: '备注', key: 'remark', align: 'center', minWidth: '80' },
  { title: '大类', key: 'bigClass', align: 'center', minWidth: '80' },
  { title: '小类', key: 'smallClass', align: 'center', minWidth: '80' },
  { title: '单件用量', key: 'totalUsage', align: 'center', minWidth: '80' },
  { title: '总用量', key: 'productTotalUsage', align: 'center', minWidth: '80' },
  { title: '关联采购', key: 'purchaseNum', align: 'center', minWidth: '80' },
  { title: '操作', key: 'actions', align: 'center', minWidth: '90' }
]

interface MaterialSummarySearchForm {
  productName: string[]
  materialName: string[]
  materialSpec: string[]
  materialCode: string[]
  bigClass: string[]
  smallClass: string[]
}

interface MetalSummarySearchForm {
  productName: string[]
  partName: string[]
  materialName: string[]
  materialSpec: string[]
  materialCode: string[]
  bigClass: string[]
  smallClass: string[]
}

const route = useRoute()
const { showError } = useSnackbar()
const purchaseDialogRef = ref<InstanceType<typeof PurchaseDialog> | null>(null)

const activeTab = ref<'material' | 'metal'>('material')
const contractId = ref(0)
const productOrderItemId = ref(0)
const titleList = ref<TitleItem[]>([
  { title: '常规材料', isChoosed: true },
  { title: '定制&五金', isChoosed: false }
])

const formatNumberUse = (num: number | string | null | undefined, decimals: number = 4): string => {
  if (num === null || num === undefined || num === '') {
    return ''
  }
  const n = typeof num === 'string' ? parseFloat(num) : num
  if (isNaN(n)) {
    return ''
  }
  return parseFloat(n.toFixed(decimals)).toString()
}

const hasValidProductCode = computed(() => {
  const q = route.query.productCode
  return q !== undefined && q !== null && q !== '' && String(q) !== 'undefined' && String(q) !== 'null'
})

const loadingMaterialSummary = ref(false)
const loadingMetalSummary = ref(false)
const materialSummaryProductList = ref<any[]>([])
const mergeProductionMetalSummaryProductItems = ref<any[]>([])

const warehouseList = ref<WarehouseItemOptions[]>([])
const formattedWarehouseList = computed(() => {
  return warehouseList.value.map(warehouse => ({
    ...warehouse,
    warehouseName: `${warehouse.warehouseName}`
  }))
})

/** 加采购项弹窗内 purchaseProductQuantityInfo 默认仓库（与列表页已加载的仓库一致） */
const addPurchaseWarehouseNo = computed(() => warehouseList.value[0]?.warehouseNo ?? '')

const materialSummaryPagination = ref({ page: 1, pageSize: 20, total: 0 })
const metalSummaryPagination = ref({ page: 1, pageSize: 20, total: 0 })
const showFactoryChoosePurchase = ref(false)
const showFactoryChoosePurchaseHardware = ref(false)
const selectedFactoryMaterials = ref<string[]>([])
const selectedHardwareMaterials = ref<string[]>([])
const selectedMaterialDetails = ref<any[]>([])
const showAddPurchaseItemDialog = ref(false)
const addPurchaseDialogRows = ref<any[]>([])
/** 转采购项弹窗标题区：与 PurchaseDialog 一致，来自合同详情 */
const addPurchaseDialogProjectName = ref<string | null>(null)
const addPurchaseDialogContractCode = ref<string | null>(null)
const currentChooseAction = ref<'direct' | 'add' | ''>('')

const materialSummaryTotalPages = computed(() =>
  Math.ceil(materialSummaryPagination.value.total / materialSummaryPagination.value.pageSize) || 1
)
const metalSummaryTotalPages = computed(() =>
  Math.ceil(metalSummaryPagination.value.total / metalSummaryPagination.value.pageSize) || 1
)

const materialSummarySearchForm = ref<MaterialSummarySearchForm>({
  productName: [],
  materialName: [],
  materialSpec: [],
  materialCode: [],
  bigClass: [],
  smallClass: []
})

const metalSummarySearchForm = ref<MetalSummarySearchForm>({
  productName: [],
  partName: [],
  materialName: [],
  materialSpec: [],
  materialCode: [],
  bigClass: [],
  smallClass: []
})

const materialproductNamesSummaryOptions = ref<string[]>([])
const materialmaterialNamesSummaryOptions = ref<string[]>([])
const materialmaterialSpecsSummaryOptions = ref<string[]>([])
const materialmaterialCodesSummaryOptions = ref<string[]>([])
const materialCodeSummaryFilterKeyword = ref('')
const filteredMaterialCodesSummaryOptions = computed(() => {
  if (!materialCodeSummaryFilterKeyword.value) return materialmaterialCodesSummaryOptions.value
  const keyword = materialCodeSummaryFilterKeyword.value.toLowerCase()
  return materialmaterialCodesSummaryOptions.value.filter(option => String(option).toLowerCase().includes(keyword))
})
const materialSpecSummaryFilterKeyword = ref('')
const filteredMaterialSpecsSummaryOptions = computed(() => {
  if (!materialSpecSummaryFilterKeyword.value) return materialmaterialSpecsSummaryOptions.value
  const keyword = materialSpecSummaryFilterKeyword.value.toLowerCase()
  return materialmaterialSpecsSummaryOptions.value.filter(option => option.toLowerCase().includes(keyword))
})
const materialbigClassesSummaryOptions = ref<string[]>([])
const materialsmallClassesSummaryOptions = ref<string[]>([])

const metalproductNamesOptions = ref<string[]>([])
const metalSummaryPartNamesOptions = ref<string[]>([])
const metalSummaryMaterialNamesOptions = ref<string[]>([])
const metalSummaryMaterialSpecsOptions = ref<string[]>([])
const metalSummaryMetalSpecFilterKeyword = ref('')
const filteredMetalSummaryMetalSpecsOptions = computed(() => {
  if (!metalSummaryMetalSpecFilterKeyword.value) return metalSummaryMaterialSpecsOptions.value
  const keyword = metalSummaryMetalSpecFilterKeyword.value.toLowerCase()
  return metalSummaryMaterialSpecsOptions.value.filter(option => option.toLowerCase().includes(keyword))
})
const metalSummaryBigClassesOptions = ref<string[]>([])
const metalSummarySmallClassesOptions = ref<string[]>([])
const metalSummaryMaterialCodesOptions = ref<string[]>([])
const metalSummaryMaterialCodeFilterKeyword = ref('')
const filteredMetalSummaryMaterialCodesOptions = computed(() => {
  if (!metalSummaryMaterialCodeFilterKeyword.value) return metalSummaryMaterialCodesOptions.value
  const keyword = metalSummaryMaterialCodeFilterKeyword.value.toLowerCase()
  return metalSummaryMaterialCodesOptions.value.filter(option => String(option).toLowerCase().includes(keyword))
})

function parseProductImageUrl(imageUrls: string): string | null {
  try {
    const arr = JSON.parse(imageUrls)
    return arr?.[0]?.url || null
  } catch {
    return null
  }
}

function productThumbSrc(imageUrls: string | undefined): string {
  if (!imageUrls) return ''
  return parseProductImageUrl(imageUrls) || ''
}

function handleProductionManufactureToDesign(item: any) {
  const url = `/design-draft/${contractId.value}/product/${item.originId}/design/see`
  window.open(url, '_blank')
}

function handleSeeMaterialPurchaseList(item: any, type: 'material' | 'hardware', groupByProduct?: number) {
  const bomKey = item.bomKey
  const jinshu = type === 'hardware' ? 1 : 0
  const url = `/contract/materialPurchaseList?contractId=${contractId.value}&bomKey=${encodeURIComponent(
    bomKey ?? ''
  )}&jinshu=${jinshu}${groupByProduct !== undefined ? `&groupByProduct=${groupByProduct}` : ''}`
  window.open(url, '_blank')
}

function handleTitleClick(index: number, _title: string) {
  titleList.value.forEach((item, i) => {
    item.isChoosed = i === index
  })
  activeTab.value = index === 0 ? 'material' : 'metal'
}

/** 定制&五金：与列表「尺寸」列一致，拼成 W/D/H 文案写入采购备注 */
const buildHardwareSizeRemarkForPurchase = (row: any): string => {
  const parts: string[] = []
  if (row?.remark) parts.push(`${row.remark}`)
  if (row?.width != null && row?.width !== '') parts.push(`W:${row.width}`)
  if (row?.depth != null && row?.depth !== '') parts.push(`D:${row.depth}`)
  if (row?.height != null && row?.height !== '') parts.push(`H:${row.height}`)
  return parts.join(' ')
}

function buildFactorySummaryKey(item: any, _productItem: any, pIndex: number, index: number) {
  return `m-${item?.bomKey ?? ''}-${item?.materialCode ?? ''}-${pIndex}-${index}`
}

function buildHardwareSummaryKey(item: any, _productItem: any, pIndex: number, index: number) {
  return `h-${item?.bomKey ?? ''}-${item?.partName ?? ''}-${item?.materialCode ?? ''}-${pIndex}-${index}`
}

function handleChooseFactorySummaryMaterial(item: any, checked: boolean, _productItem: any, pIndex: number, index: number) {
  // if (!isUnpurchasedRow(item)) return
  const key = buildFactorySummaryKey(item, _productItem, pIndex, index)
  const arr = selectedFactoryMaterials.value
  const detailIndex = selectedMaterialDetails.value.findIndex((m: any) => m._selectedKey === key)
  if (checked) {
    if (!arr.includes(key)) arr.push(key)
    if (detailIndex < 0) {
      selectedMaterialDetails.value.push({
        ...item,
        _selectedKey: key,
        materialCount: item.productUsageSum || item.totalUsage || null,
        purchasePrice: null
      })
    }
  } else {
    const i = arr.indexOf(key)
    if (i > -1) arr.splice(i, 1)
    if (detailIndex > -1) selectedMaterialDetails.value.splice(detailIndex, 1)
  }
}

function handleChooseHardwareSummaryMaterial(item: any, checked: boolean, _productItem: any, pIndex: number, index: number) {
  // if (!isUnpurchasedRow(item)) return
  const key = buildHardwareSummaryKey(item, _productItem, pIndex, index)
  const arr = selectedHardwareMaterials.value
  const detailIndex = selectedMaterialDetails.value.findIndex((m: any) => m._selectedKey === key)
  if (checked) {
    if (!arr.includes(key)) arr.push(key)
    if (detailIndex < 0) {
      selectedMaterialDetails.value.push({
        ...item,
        _selectedKey: key,
        materialCount: item.productUsageSum || item.totalUsage || null,
        purchasePrice: null
      })
    }
  } else {
    const i = arr.indexOf(key)
    if (i > -1) arr.splice(i, 1)
    if (detailIndex > -1) selectedMaterialDetails.value.splice(detailIndex, 1)
  }
}

function getCurrentSummaryRows() {
  const rows: any[] = []
  const sourceList =
    activeTab.value === 'material'
      ? materialSummaryProductList.value
      : mergeProductionMetalSummaryProductItems.value
  sourceList.forEach((productItem: any) => {
    const summaryList = productItem?.summaryList || []
    summaryList.forEach((row: any) => {
      rows.push({ ...row, _product: productItem?.product })
    })
  })
  return rows
}

function isUnpurchasedRow(row: any) {
  const hasPurchaseList = Array.isArray(row?.purchaseList) && row.purchaseList.length > 0
  const purchaseNum = Number(row?.purchaseNum ?? 0)
  return !hasPurchaseList && purchaseNum <= 0
}

function buildTempRequisitionForPurchaseDialog() {
  const rows = [...selectedMaterialDetails.value]
  if (rows.length === 0) {
    showError('请至少选择一个物料')
    return null
  }

  const purchaseEntry = activeTab.value === 'material' ? 'factoryMaterial' : 'factoryHardware'
  const defaultItemType = purchaseEntry === 'factoryMaterial' ? 1 : 0
  const items = rows.map((row: any, idx: number) => ({
    id: row?.id ?? idx + 1,
    requisitionId: null,
    materialCode: row?.materialCode ?? row?.code ?? '',
    materialName: row?.materialName ?? row?.partName ?? '',
    materialSpec: row?.materialSpec ?? '',
    materialTotalCount: row?.productUsageSum ?? null,
    _originalMaterialUnit: row?.materialUsageUnit ?? row?.unit ?? '',
    brand: row?.brand ?? '',
    quantity: row?.productUsageSum ?? row?.totalUsage ?? null,
    remark: purchaseEntry === 'factoryHardware'
      ? (buildHardwareSizeRemarkForPurchase(row) || (row?.remark ?? row?.materialRemark ?? ''))
      : (row?.remark ?? row?.materialRemark ?? ''),
    plannedDeliveryDate: row?.plannedDeliveryDate ?? '',
    warehouseNo: row?.warehouseNo ?? '',
    warehouseName: row?.warehouseName ?? '',
    batch: row?._product?.batch,
    syscode: row?._product?.syscode,
    type: row?.type ?? '',
    itemType: row?.itemType ?? defaultItemType,
    materialRemark: row?.materialRemark,
    materialType: row?.materialType,
    bigClass: row?.bigClass,
    smallClass: row?.smallClass,
    bomKey: row?.bomKey,
    partName: row?.partName,
    productCodes: row?.productCodes || []
  }))

  return {
    id: null,
    requisitionNo: '',
    warehouseNo: '',
    warehouseName: '',
    items,
    _purchaseEntry: purchaseEntry
  }
}

function handleAddPurchaseItemsSuccess() {
  loadMaterialSummaryMerge()
  loadMetalSummaryMerge()
}

function handleAddPurchase() {
  if (activeTab.value === 'material' && !showFactoryChoosePurchase.value) {
    showFactoryChoosePurchase.value = true
    showFactoryChoosePurchaseHardware.value = false
    currentChooseAction.value = 'add'
    selectedFactoryMaterials.value = []
    selectedHardwareMaterials.value = []
    selectedMaterialDetails.value = []
    return
  }
  if (activeTab.value === 'metal' && !showFactoryChoosePurchaseHardware.value) {
    showFactoryChoosePurchaseHardware.value = true
    showFactoryChoosePurchase.value = false
    currentChooseAction.value = 'add'
    selectedFactoryMaterials.value = []
    selectedHardwareMaterials.value = []
    selectedMaterialDetails.value = []
    return
  }
  if (currentChooseAction.value !== 'add') {
    showError('当前为直接采购选择状态，请先完成或切换')
    return
  }
  if (!selectedMaterialDetails.value.length) {
    showError('请至少选择一个未采购物料')
    return
  }
  addPurchaseDialogRows.value = selectedMaterialDetails.value.map((row: any) => ({
    ...row,
    itemType: activeTab.value === 'material' ? 1 : 0,
    remark: activeTab.value === 'metal'
      ? (buildHardwareSizeRemarkForPurchase(row) || (row?.remark ?? row?.materialRemark ?? ''))
      : (row?.remark ?? row?.materialRemark ?? ''),
  }))
  showFactoryChoosePurchase.value = false
  showFactoryChoosePurchaseHardware.value = false
  selectedFactoryMaterials.value = []
  selectedHardwareMaterials.value = []
  selectedMaterialDetails.value = []
  currentChooseAction.value = ''
  showAddPurchaseItemDialog.value = true
}

function handleDirectPurchase() {
  if (activeTab.value === 'material' && !showFactoryChoosePurchase.value) {
    showFactoryChoosePurchase.value = true
    showFactoryChoosePurchaseHardware.value = false
    currentChooseAction.value = 'direct'
    selectedFactoryMaterials.value = []
    selectedHardwareMaterials.value = []
    selectedMaterialDetails.value = []
    return
  }
  if (activeTab.value === 'metal' && !showFactoryChoosePurchaseHardware.value) {
    showFactoryChoosePurchaseHardware.value = true
    showFactoryChoosePurchase.value = false
    currentChooseAction.value = 'direct'
    selectedFactoryMaterials.value = []
    selectedHardwareMaterials.value = []
    selectedMaterialDetails.value = []
    return
  }
  if (currentChooseAction.value !== 'direct') {
    showError('当前为加采购项选择状态，请先完成或切换')
    return
  }
  const temp = buildTempRequisitionForPurchaseDialog()
  if (!temp) return
  purchaseDialogRef.value?.openForRequisition(temp, -1)
}

function handlePurchaseSuccessFromDialog() {
  showFactoryChoosePurchase.value = false
  showFactoryChoosePurchaseHardware.value = false
  currentChooseAction.value = ''
  selectedFactoryMaterials.value = []
  selectedHardwareMaterials.value = []
  selectedMaterialDetails.value = []
  loadMaterialSummaryMerge()
  loadMetalSummaryMerge()
}

function handleCancelPurchase() {
  showFactoryChoosePurchase.value = false
  showFactoryChoosePurchaseHardware.value = false
  currentChooseAction.value = ''
  selectedFactoryMaterials.value = []
  selectedHardwareMaterials.value = []
  selectedMaterialDetails.value = []
}

function startDirectPurchase() {
  currentChooseAction.value = 'direct'
  if (activeTab.value === 'material') {
    showFactoryChoosePurchase.value = true
    showFactoryChoosePurchaseHardware.value = false
  } else {
    showFactoryChoosePurchaseHardware.value = true
    showFactoryChoosePurchase.value = false
  }
}

function startAddPurchase() {
  currentChooseAction.value = 'add'
  if (activeTab.value === 'material') {
    showFactoryChoosePurchase.value = true
    showFactoryChoosePurchaseHardware.value = false
  } else {
    showFactoryChoosePurchaseHardware.value = true
    showFactoryChoosePurchase.value = false
  }
}

function handleSummaryCheckboxChange(field: keyof MaterialSummarySearchForm, value: string, checked: any) {
  const arr = materialSummarySearchForm.value[field]
  if (checked) {
    if (!arr.includes(value)) arr.push(value)
  } else {
    const i = arr.indexOf(value)
    if (i > -1) arr.splice(i, 1)
  }
  materialSummaryPagination.value.page = 1
  materialSummaryProductList.value = []
  loadMaterialSummaryMerge()
}

function handleMetalSummaryCheckboxChange(field: keyof MetalSummarySearchForm, value: string, checked: any) {
  const arr = metalSummarySearchForm.value[field]
  if (checked) {
    if (!arr.includes(value)) arr.push(value)
  } else {
    const i = arr.indexOf(value)
    if (i > -1) arr.splice(i, 1)
  }
  metalSummaryPagination.value.page = 1
  mergeProductionMetalSummaryProductItems.value = []
  loadMetalSummaryMerge()
}

function handleMaterialSummaryPageChange(newPage: number) {
  materialSummaryPagination.value.page = newPage
  materialSummaryProductList.value = []
  loadMaterialSummaryMerge()
}

function handleMetalSummaryPageChange(newPage: number) {
  metalSummaryPagination.value.page = newPage
  mergeProductionMetalSummaryProductItems.value = []
  loadMetalSummaryMerge()
}

async function loadMaterialSummaryMerge() {
  if (!hasValidProductCode.value) return
  loadingMaterialSummary.value = true
  try {
    const params: Record<string, any> = {
      contractId: contractId.value,
      productOrderItemId: productOrderItemId.value,
      from: 0,
      jinshu: 0,
      page: materialSummaryPagination.value.page,
      pageSize: materialSummaryPagination.value.pageSize,
      groupByProduct: 1
    }
    const f = materialSummarySearchForm.value
    if (f.materialName.length) params.materialName = f.materialName.join(',')
    if (f.materialSpec.length) params.materialSpec = f.materialSpec.join(',')
    if (f.bigClass.length) params.bigClass = f.bigClass.join(',')
    if (f.smallClass.length) params.smallClass = f.smallClass.join(',')
    if (f.productName.length) params.productName = f.productName.join(',')
    if (f.materialCode.length) params.materialCode = f.materialCode.join(',')

    const res = (await contractApi.loadMaterialSummaryMerge(params)) as unknown as ApiResponse
    if (res.code === 0 && res?.data) {
      materialSummaryProductList.value = res.data.products || []
      materialSummaryPagination.value.total = res.data.pagination?.total || 0
      materialproductNamesSummaryOptions.value = res.data.filterValues.productNames
      materialmaterialNamesSummaryOptions.value = res.data.filterValues.materialNames
      materialmaterialSpecsSummaryOptions.value = res.data.filterValues.materialSpecs
      materialmaterialCodesSummaryOptions.value = res.data.filterValues.materialCodes || []
      materialbigClassesSummaryOptions.value = res.data.filterValues.bigClasses
      materialsmallClassesSummaryOptions.value = res.data.filterValues.smallClasses
    } else {
      showError(res?.message || '加载失败')
    }
  } finally {
    loadingMaterialSummary.value = false
  }
}

async function loadMetalSummaryMerge() {
  if (!hasValidProductCode.value) return
  loadingMetalSummary.value = true
  try {
    const params: Record<string, any> = {
      contractId: contractId.value,
      productOrderItemId: productOrderItemId.value,
      from: 0,
      jinshu: 1,
      page: metalSummaryPagination.value.page,
      pageSize: metalSummaryPagination.value.pageSize,
      groupByProduct: 1
    }
    const f = metalSummarySearchForm.value
    if (f.productName.length) params.productName = f.productName.join(',')
    if (f.partName.length) params.partName = f.partName.join(',')
    if (f.materialName.length) params.materialName = f.materialName.join(',')
    if (f.materialSpec.length) params.materialSpec = f.materialSpec.join(',')
    if (f.bigClass.length) params.bigClass = f.bigClass.join(',')
    if (f.smallClass.length) params.smallClass = f.smallClass.join(',')
    if (f.materialCode.length) params.materialCode = f.materialCode.join(',')

    const res = (await contractApi.loadMaterialSummaryMerge(params)) as unknown as ApiResponse
    if (res.code === 0 && res?.data) {
      mergeProductionMetalSummaryProductItems.value = res.data.products || []
      metalSummaryPagination.value.total = res.data.pagination?.total || 0
      metalproductNamesOptions.value = res.data.filterValues.productNames || []
      metalSummaryPartNamesOptions.value = res.data.filterValues.partNames || []
      metalSummaryMaterialNamesOptions.value = res.data.filterValues.materialNames || []
      metalSummaryMaterialSpecsOptions.value = res.data.filterValues.materialSpecs || []
      metalSummaryMaterialCodesOptions.value = res.data.filterValues.materialCodes || []
      metalSummaryBigClassesOptions.value = res.data.filterValues.bigClasses || []
      metalSummarySmallClassesOptions.value = res.data.filterValues.smallClasses || []
    } else {
      showError(res?.message || '加载失败')
    }
    document.title = '料单'
  } finally {
    loadingMetalSummary.value = false
  }
  document.title = '料单'
}

function syncContractIdFromRoute() {
  contractId.value = Number(route.query.productCode)
  productOrderItemId.value = Number(route.query.productOrderItemId)
}

async function loadAddPurchaseContractHeader() {
  if (!hasValidProductCode.value || !contractId.value) {
    addPurchaseDialogProjectName.value = null
    addPurchaseDialogContractCode.value = null
    return
  }
  try {
    const res = (await contractApi.getDetail(Number(contractId.value))) as unknown as ApiResponse
    if (res?.code === 0 && res.data) {
      addPurchaseDialogProjectName.value = res.data.project ?? null
      addPurchaseDialogContractCode.value = res.data.code ?? null
    } else {
      addPurchaseDialogProjectName.value = null
      addPurchaseDialogContractCode.value = null
    }
  } catch (error) {
    console.error('获取合同信息失败:', error)
    addPurchaseDialogProjectName.value = null
    addPurchaseDialogContractCode.value = null
  }
}

onMounted(() => {
  syncContractIdFromRoute()
  loadWarehouseList()
  if (hasValidProductCode.value) {
    loadMaterialSummaryMerge()
    loadMetalSummaryMerge()
    loadAddPurchaseContractHeader()
  }
})

watch(
  () => route.query.productCode,
  () => {
    syncContractIdFromRoute()
    if (hasValidProductCode.value) {
      materialSummaryPagination.value.page = 1
      metalSummaryPagination.value.page = 1
      loadMaterialSummaryMerge()
      loadMetalSummaryMerge()
      loadAddPurchaseContractHeader()
    } else {
      addPurchaseDialogProjectName.value = null
      addPurchaseDialogContractCode.value = null
    }
  }
)

watch(activeTab, val => {
  titleList.value[0].isChoosed = val === 'material'
  titleList.value[1].isChoosed = val === 'metal'
  showFactoryChoosePurchase.value = false
  showFactoryChoosePurchaseHardware.value = false
  currentChooseAction.value = ''
  selectedFactoryMaterials.value = []
  selectedHardwareMaterials.value = []
  selectedMaterialDetails.value = []
})

// 获取仓库列表
const loadWarehouseList = async () => {
  try {
    const res = await goodsManageApi.getWarehouseList()
    if (res.code === 0) {
      warehouseList.value = res.data || []
    } else {
      warehouseList.value = []
    }
  } catch (error) {
    console.error('获取仓库列表失败:', error)
    warehouseList.value = []
  }
}
</script>

<style scoped lang="scss">
.mlp-summary-page {
  min-height: 100vh;
  width: 100%;
  background: #2b2d33;
  padding: 16px;
  box-sizing: border-box;
}
.mlp-summary-inner {
  max-width: 1480px;
  margin: 0 auto;
}
.mlp-title-row {
  margin-bottom: 12px;
}
.mlp-title {
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  margin: 0;
}
.mlp-sub {
  display: block;
  margin-top: 4px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.65);
}
.mlp-header-em {
  color: #d2475d;
  font-weight: 800;
}
.section-title-group {
  display: flex;
  gap: 16px;
  // margin-top: 40px;
  position: relative;
}
.normal-title {
  color: #fff;
  cursor: pointer;
  width: 106px;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
  padding-left: 8px;
}
.normal-title-active {
  border-left: 3px solid #D2475D;
}

.section-title-group div{
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  width: 106px;
  box-sizing: border-box;
  color: rgba(255, 255, 255, 0.6)!important;
}

.section-title-group div.section-title{
  color: #fff!important;
}

.filter-menu {
  background-color: #2B2D33 !important;
  border: 1px solid rgba(255, 255, 255, 0.12);
}
.filter-menu :deep(.v-card-text) {
  max-height: 400px;
  overflow-y: auto;
}
:deep(.filter-btn-active .mdi-filter::before) {
  color: #D2475D !important;
}
.filter-btn-active {
  opacity: 1 !important;
}
.product-table-container {
  color: #e0e0e0;
  position: relative;
  z-index: 150;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
}
.table-border {
  border-top: 1px solid rgba(255, 255, 255, 0.12) !important;
}
.product-table {
  background-color: transparent;
  width: 100%;
  table-layout: fixed;
  min-width: 1200px;
  border-collapse: separate;
  border-spacing: 0;
}

.material-table {
  background-color: transparent;
  width: 100%;
  table-layout: fixed;
  min-width: 1200px;
  border-collapse: separate;
  border-spacing: 0;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) rgba(255, 255, 255, 0.05);
}

.product-table :deep(.v-table__wrapper),
.material-table :deep(.v-table__wrapper) {
  overflow-x: hidden;
  background-color: #2B2D33 !important;
}

.product-table :deep(table),
.material-table :deep(table),
.product-table :deep(tbody),
.material-table :deep(tbody),
.product-table :deep(tr),
.material-table :deep(tr),
.product-table :deep(td),
.material-table :deep(td) {
  background-color: #2B2D33 !important;
}

.material-summary-table :deep(th),
.material-summary-table :deep(td) {
  border-left: none !important;
  border-right: none !important;
  border-top: none !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
  font-size: 13px;
}
.material-summary-table :deep(thead th) {
  background: #33353b !important;
  color: #fff !important;
}

.material-summary-table-body tr td{
  word-break: break-all!important;
  white-space: normal!important;
  color: #fff;
}

.material-summary-table :deep(.filter-btn){
  margin-left: 0!important;
}

.material-summary-table :deep(.v-checkbox){
  display: flex;
  justify-content: center;
}

.material-summary-table-body td:last-child > * {
  margin: 0px!important;
}

.material-table td:last-child > * {
  margin-right: 0px!important;
  margin: 6px auto 8px auto!important;
}

.material-summary-table-body tr{
  height: 80px;
  box-sizing: border-box;
}

.custom-pagination{
  padding: 16px!important;
  border-top: 1px solid rgba(255, 255, 255, 0.12)!important;
}

.custom-pagination .pagination-info {
  font-size: 14px;
}

.custom-pagination .pagination-controls {
  display: flex;
  align-items: center;
}

.custom-pagination .pagination-btn {
  color: rgba(255, 255, 255, 0.7) !important;
}

.custom-pagination .pagination-btn:hover {
  color: #fff !important;
}

.custom-pagination .pagination-btn:disabled {
  color: rgba(255, 255, 255, 0.3) !important;
}

.custom-pagination .pagination-text {
  font-size: 14px;
}

:deep(.product-info-cell-border) {
  border-left: 1px solid rgba(255, 255, 255, 0.12) !important;
  border-right: 1px solid rgba(255, 255, 255, 0.12) !important;
}

.material-summary-table :deep(td.product-info-cell-border) {
  border-left: 1px solid rgba(255, 255, 255, 0.12) !important;
  border-right: 1px solid rgba(255, 255, 255, 0.12) !important;
}

.no-img {
  background: rgba(0, 0, 0, 0.25);
}

.material-list::-webkit-scrollbar,
.material-table::-webkit-scrollbar,
:deep(.filter-menu-text::-webkit-scrollbar) {
  width: 8px;
  height: 8px;
}

.material-list::-webkit-scrollbar-thumb,
.material-table::-webkit-scrollbar-thumb,
:deep(.filter-menu-text::-webkit-scrollbar-thumb) {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.1) 100%);
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.material-list::-webkit-scrollbar-thumb:hover,
.material-table::-webkit-scrollbar-thumb:hover,
:deep(.filter-menu-text::-webkit-scrollbar-thumb:hover) {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0.2) 100%);
  border-color: rgba(255, 255, 255, 0.2);
  transform: scale(1.1);
}

.material-list::-webkit-scrollbar-thumb:active,
.material-table::-webkit-scrollbar-thumb:active,
:deep(.filter-menu-text::-webkit-scrollbar-thumb:active) {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0.3) 100%);
}

.material-list::-webkit-scrollbar-track,
.material-table::-webkit-scrollbar-track,
:deep(.filter-menu-text::-webkit-scrollbar-track) {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
}

.material-list::-webkit-scrollbar-corner,
.material-table::-webkit-scrollbar-corner,
:deep(.filter-menu-text::-webkit-scrollbar-corner) {
  background: transparent;
}

:deep(.filter-menu-text){
  color: #fff;
}

.form-actions {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  background-color: rgba(43, 45, 51, 0.95);
  backdrop-filter: blur(8px);
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
  z-index: 100;
}

.form-actions .v-btn {
  min-width: 120px;
  margin-right: 16px;
}

:deep(.v-selection-control__input .mdi::before) {
  color: #D2475D !important;
  font-size: 18px !important;
}

:deep(.v-progress-circular),:deep(.filter-btn-active .mdi-filter::before){
  color: #D2475D !important;
}

.statusImg{
  width: 52px;
  height: 22px;
  display: inline-block;
  margin: 0 auto;
}
</style>
